import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const looker = defineConnector({
  identifier: "looker",
  name: "Looker",
  tagLine: "Business intelligence and analytics platform",
  keywords: "bi business intelligence google dashboards lookml explores",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.instanceUrl}/api/4.0/login`,
        formBody: {
          client_id: app.config.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "token" },
    }),
  steps: [
    {
      title: "Create Looker API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Looker, go to **Admin → Users**, open an API-only or admin user, and create API credentials. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your Looker details",
      items: [
        {
          kind: "baseUrl",
          label: "Looker API base URL",
          required: true,
          placeholder: "https://company.cloud.looker.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "Your Looker API host. Self-hosted Looker uses port 19999 (e.g., https://looker.example.com:19999); cloud Looker uses the default port 443.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl}/api/4.0/user`,
      expectedStatus: 200,
    }),
  },
  publicEnvVars: ({ instanceUrl }) => ({
    LOOKER_URL: instanceUrl || "",
  }),
});
